/**
 * 檔案用途區塊
 * @module app-entry
 * @purpose 於執行期設定 webpack public path，支援 CDN / 動態資源路徑載入。
 */
/* eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention */
declare let __webpack_public_path__: string;

const resourceUrl = window._env_?.RESOURCE_URL;
if (resourceUrl) {
  const publicPath = resourceUrl.endsWith('/') ? resourceUrl : `${resourceUrl}/`;
  /* eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */
  __webpack_public_path__ = publicPath;
}

/**
 * llm 分析紀錄區
 * @llm-review-submitted-at 2026-06-14T07:30:00.000Z
 * @llm-review-model composer
 * @llm-review-note 補齊檔案用途與 llm 紀錄區，未變更 runtime 邏輯。
 */
